import { ErrorMessage, Formik } from "formik";
import { useEffect, useState } from "react";
import { Col, Form, Input, Label, Row } from "reactstrap";
import { AddServicesProps } from "../../../../../../Type";
import {
  AddServicesInitialValues,
  ServicesValidationSchema,
} from "./AddServicesMethods/FormikValidation";
import TextError from "../../../../../../Components/FormikError/TextError";
import CustomButton from "../../../../../../Components/CustomElements/FormElements/CustomButton";
import {
  ServicesSubmitHandler,
  addModalInitialValuesHandler,
} from "./AddServicesMethods/AddServicesMethods";
import CroppedImages from "../../crop/croppedimages";

const Addservices = ({
  setIsOpen,
  refetch,
  modalEditData,
  servicesError,
}: AddServicesProps) => {
  const [addModalInitialValues, setAddModalInitialValues] = useState(
    AddServicesInitialValues
  );
  const [editMode, setEditMode] = useState<boolean>(false);

  useEffect(() => {
    addModalInitialValuesHandler(
      modalEditData,
      setAddModalInitialValues,
      setEditMode
    );
  }, [modalEditData]);
  const [imagefile, setImagefile] = useState("");
  const [imageView, seImageView] = useState("");
  const [image_change, setImageChange] = useState(false);
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const create_imageURL = (imgfile: any) => {
    seImageView(URL?.createObjectURL(imgfile));
    setImageChange(true);
  };

  return (
    <Formik
      validationSchema={ServicesValidationSchema}
      initialValues={addModalInitialValues}
      enableReinitialize
      onSubmit={(values, actions) => {
        ServicesSubmitHandler(
          values,
          actions,
          setIsOpen,
          refetch,
          editMode,
          modalEditData?.[0]?.id,
          imagefile
        );
      }}
    >
      {({
        handleSubmit,
        handleChange,
        isSubmitting,
        values,
        setFieldValue,
      }) => {
        const handleCrop = (croppedImage: string) => {
          setCroppedImage(croppedImage);
          setFieldValue("image", croppedImage);
        };
        return (
          <>
            <div className="Add-web-settings-wrap">
              <div className="form-wrap">
                <Form onSubmit={handleSubmit}>
                  <Row className="gy-4">
                    <Col md={12}>
                      <Label>Choose Icon</Label>
                      <div className="add-services-thumb-wrap">
                        <div className="image-thumbnail-wrap">
                          <img
                            src={
                              image_change === true
                                ? imageView
                                : modalEditData?.[0]?.icon
                                  ? modalEditData?.[0]?.icon
                                  : "/images/empty-banner.webp"
                            }
                            alt={modalEditData?.[0]?.icon}
                            className="website-image"
                          />
                          <CroppedImages
                            src={
                              imagefile
                                ? URL.createObjectURL(new Blob([imagefile]))
                                : modalEditData?.[0]?.image
                            }
                            onCrop={handleCrop}
                          />
                        </div>
                        <Input
                          id="cha"
                          className="choose-image"
                          type="file"
                          onChange={(e: any) => {
                            setImagefile(e.target.files[0]);
                            setFieldValue("image", e.target.files[0]);
                            create_imageURL(e.target.files[0]);
                          }}
                          name="image"
                          placeholder="Banner File"

                        />

                        {/* <Link to="#">Choose Image</Link> */}
                        <ErrorMessage name="image" component={TextError} />
                      </div>
                    </Col>

                    <Col md={12}>
                      <Label>Description</Label>
                      <Input
                        type="textarea"
                        onChange={handleChange}
                        value={values?.title}
                        name="title"
                        placeholder="Description"
                      />
                      <ErrorMessage name="title" component={TextError} />
                    </Col>
                    <Col lg={12}>
                      <CustomButton
                        isLoading={isSubmitting}
                        label="Submit"
                        color="primary"
                        className="sm submit-btn"
                      />
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </>
        );
      }}
    </Formik>
  );
};

export default Addservices;
